/**
 * Quick Shop — Mobile Popup Fix
 *
 * The mobile quick-shop drawer uses `position: fixed` on its wrapper to
 * float over the viewport. If ANY ancestor has a transform / filter /
 * will-change / contain, the fixed positioning gets trapped inside that
 * ancestor and the drawer appears pinned to the product card instead of
 * the viewport.
 *
 * This script relocates the <quick-shop> element to <body> the moment it
 * becomes active on mobile, and returns it to its original parent on
 * close. Desktop behavior (Magnific Popup modal) is untouched.
 */
(function () {
  'use strict';

  var MOBILE_BRKP = 768; // matches theme.mobileBrkp

  function isMobile() {
    return window.innerWidth < MOBILE_BRKP;
  }

  function setupQuickShop(qs) {
    if (qs.__mobilePopupPatched) return;
    qs.__mobilePopupPatched = true;

    // Remember original home so we can move it back on close.
    var originalParent = qs.parentElement;
    var originalNextSibling = qs.nextSibling;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName !== 'class') return;

        var isActive = qs.classList.contains('active');

        if (isActive && isMobile() && qs.parentElement !== document.body) {
          // Remember current home (could have changed) and move to body.
          originalParent = qs.parentElement;
          originalNextSibling = qs.nextSibling;
          qs.classList.add('quick-shop--mobile-popup');
          document.body.appendChild(qs);
        } else if (!isActive && qs.parentElement === document.body) {
          // Put it back so the theme's normal logic still works.
          qs.classList.remove('quick-shop--mobile-popup');
          if (originalParent && originalParent.isConnected) {
            if (originalNextSibling && originalNextSibling.parentElement === originalParent) {
              originalParent.insertBefore(qs, originalNextSibling);
            } else {
              originalParent.appendChild(qs);
            }
          }
        }
      });
    });

    observer.observe(qs, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    document.querySelectorAll('quick-shop').forEach(setupQuickShop);

    // Catch quick-shops added later (e.g., by ajax product loads, infinite scroll).
    var bodyObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.tagName && node.tagName.toLowerCase() === 'quick-shop') {
            setupQuickShop(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('quick-shop').forEach(setupQuickShop);
          }
        });
      });
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();